// Uncaught errors, unhandled promise rejections, and failed loads of images,
// scripts and stylesheets (which fire a non-bubbling error event on the element).

import { serialise, inlineText, isError, truncate } from '../../shared/serialise.js';
import { shortUrl } from '../net-utils.js';

export function installErrors(ctx, win = window) {
  win.addEventListener(
    'error',
    (event) => {
      try {
        const target = event.target;
        if (target && target !== win && target.nodeType === 1) {
          if (ctx.isOwnNode(target)) return;
          const url = target.currentSrc || target.src || target.href || '';
          if (!url || ctx.isOwnUrl(url)) return;
          const tag = target.tagName.toLowerCase();
          ctx.push('resource', 'error', `Failed to load ${tag}: ${shortUrl(ctx.redact.url(url))}`, {
            url: ctx.redact.url(url),
            tag,
            failed: true,
          });
          return;
        }
        const error = event.error;
        const message = event.message || (error && error.message) || 'Unknown error';
        ctx.push('error', 'error', truncate(message, 300), {
          message,
          name: error && error.name,
          filename: event.filename || undefined,
          line: event.lineno || undefined,
          column: event.colno || undefined,
          stack: error && error.stack ? truncate(String(error.stack), 8000) : undefined,
          crossOrigin: message === 'Script error.' || undefined,
          ownScript: (event.filename && ctx.isOwnUrl(event.filename)) || undefined,
        });
      } catch {
        // ignore
      }
    },
    true,
  );

  win.addEventListener('unhandledrejection', (event) => {
    try {
      const reason = event.reason;
      const text = isError(reason) ? `${reason.name}: ${reason.message}` : inlineText(reason, 200);
      ctx.push('error', 'error', `Unhandled promise rejection: ${text}`, {
        reason: serialise(reason, { maxLength: ctx.config.maxArgLength }),
        stack: isError(reason) && reason.stack ? truncate(String(reason.stack), 8000) : undefined,
        unhandledRejection: true,
      });
    } catch {
      // ignore
    }
  });
}
